import {Component, input} from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false
})
export class LoaderComponent {
  readonly overlay = input(false);
  readonly message = input('');
  readonly size = input<'sm' | 'md' | 'lg'>('md');
}
